import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormisForm, MCDialog, MCFormValidationService, MCResponse, RESPONSE_STATUS_CODE } from "@maslul/common-services";
import { MCButtonComponent, MCDialogComponent, MCFieldFormComponent } from "@maslul/common-components";
import { DeclarationsService } from "../../../../../services/pages/declarations/declarations";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { DialogModule } from 'primeng/dialog';
import cloneDeep from "clone-deep";
import { DeclarationsStore } from "../../../../../services/store/declarations";
import { TranslateService } from "@ngx-translate/core";
import { SendDialogComponent } from "../../components/send-dialog/send-dialog";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { GeneralStore } from "../../../../../services/store/general";
import { SendService } from "../../../../../services/general/send";
import { RequestApprovalTypeDetailsStore } from "../../../../../services/store/approval-type-details-store";
import { TABS } from "../../../../../enum/request/TABS";

@Component({
    selector: 'mi-declarations',
    imports: [CommonModule,
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        DialogModule,
        GeneralSkeletonComponent,
        MCDialogComponent,
        SendDialogComponent,
        FocusOnTabDirective
    ],
    templateUrl: './declarations.html',
    styleUrl: './declarations.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class DeclarationsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    formisForm: FormisForm = new FormisForm();
    subscribtion: Subscription = new Subscription();
    displaySuccessDialog: boolean = false;
    tabsText: any;

    dialogProperties: MCDialog = new MCDialog();

    genericText: any;

    unionReqiestId: number = 0;
    isSuccessSend: boolean = false;
    isExistAtachmnets: boolean = true;

    constructor(private declarationsService: DeclarationsService
        , private declarationsStore: DeclarationsStore
        , private formValidationService: MCFormValidationService
        , public override router: Router
        , private translateService: TranslateService
        , private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore
        , private generalStore: GeneralStore
        , private sendService: SendService) {

        super(router);
    }

    ngOnInit() {
        this.initIsExistAttachments();
        this.initDialog();
        this.initFormisForm();
        this.initText();
    }

    initIsExistAttachments() {
        this.isExistAtachmnets = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.ATTACHMENTS);
    }

    initDialog() {
        //todo  dialogProperties.breakpoints to enum
        this.dialogProperties.breakpoints = {
            '960px': '100vw', // ברוחב 960px ומטה, רוחב הדיאלוג יהיה 75vw
            '640px': '80vw' // ברוחב 640px ומטה, רוחב הדיאלוג יהיה 80
        };
    }

    initText() {
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
    }


    initFormisForm() {
        this.formisForm.options.formState = cloneDeep(this.generalStore.getSnapshot().formState);
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.declarationsStore.getSnapshot().formisFormModel);
        this.initFields();


    }
    initFields() {
        this.subscribtion.add(
            this.declarationsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    back() {
        this.declarationsStore.setFormisFormModel(cloneDeep(this.formisForm.model));
        if (this.isExistAtachmnets) {
            this.navigation('attachments')
        } else {
            this.navigation('request-details');
        }
    }

    next() {
        this.send();
    }

    send() {

        const isValid = this.formisForm.form.valid;

        this.declarationsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid) {
            this.sendService.send().subscribe({
                next: (res: MCResponse) => {
                    this.dialogProperties.visible = true

                    if (res && res.code === RESPONSE_STATUS_CODE.SUCCESS) {
                        this.unionReqiestId = res.data
                        this.isSuccessSend = true;
                    }
                    else {
                        this.isSuccessSend = false;
                    }
                },
                error: () => {
                    this.isSuccessSend = false;
                    this.dialogProperties.visible = true

                }
            })

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('declarations details get invalid field', invalidFields);


        }
    }



    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}